// Great-circle distance between two lat/lng points, in miles. Used by the
// Activities distance filter to measure each place against the user's
// current location. Hand-rolled haversine — no dependency earns its place
// for one formula.
const EARTH_RADIUS_MILES = 3958.8

const toRad = (deg: number): number => (deg * Math.PI) / 180

export const haversineMiles = (
	aLat: number,
	aLng: number,
	bLat: number,
	bLng: number,
): number => {
	const dLat = toRad(bLat - aLat)
	const dLng = toRad(bLng - aLng)
	const h =
		Math.sin(dLat / 2) ** 2 +
		Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2
	return EARTH_RADIUS_MILES * 2 * Math.asin(Math.sqrt(h))
}
